var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContentLoader',{attrs:{"viewBox":_vm.viewBox,"height":_vm.height,"width":_vm.width}},[_c('rect',{attrs:{"x":"30","y":"40","rx":"6","ry":"6","width":"100","height":"20"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }